export const NAVIGATE = 'NAVIGATE'



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/